var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center text-center leading-none mt-6 sm:mt-8"},[_c('p',[_vm._v(" Discover your office move personality ")])])}]

export { render, staticRenderFns }